import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "e540001d-4377-497a-ba87-8f0f6b4bcdef",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    suffixText: "Hz",
    prefixText: "Input the resonance frequency value rounded to the nearest integer:",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 111,
};
